import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
export function defineChain(chain) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    fees = chain.fees,
    formatters = chain.formatters,
    serializers = chain.serializers
  } = config;
  return _objectSpread(_objectSpread({}, chain), {}, {
    fees,
    formatters,
    serializers
  });
}
//# sourceMappingURL=defineChain.js.map